// extracted by mini-css-extract-plugin
export default {"ContactForm":"paymentstatus_ContactForm__mPv1I","submitButton":"paymentstatus_submitButton__fRtA7","success":"paymentstatus_success__8nxuk"};